import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core'
import { getThumbnail, imageUrl } from '@helpers/common'
import { Observable } from 'rxjs'

@Component({
    selector: 'app-base-video',
    templateUrl: './base-video.component.html',
    styleUrls: ['./base-video.component.css'],
})
export class BaseVideoComponent implements OnInit {
    @Input() videoSrc: string = ''
    @Input() videoType: string = 'video/mp4'
    @Input() preload: string = 'auto'
    @Input() width: any = ''
    @Input() height: any = ''
    @Input() type: string = ''
    @Input() autoStart = false
    @Input() playsInline = true
    @Input() withControl = false

    @ViewChild('video') video: ElementRef

    urlThumbnail = ''
    pauseVideo = true
    _videoId: string
    _openFullScreen = false
    private blobMode = false

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        const currentItem = changes.videoId
        if (currentItem) {
            this.setVideoSrcAndThumb(currentItem.currentValue)
        }
    }

    pauseVid(event, pause) {
        event.stopPropagation()
        //const video = event.target
        // this.initVideo(video).subscribe(() => {
        //console.debug('pause', pause)
        //if (pause) {
        //    video.play()
        //    this.pauseVideo = false
        //} else {
        //    video.pause()
        //    this.pauseVideo = true
        //}
        // })
    }

    fixError(event) {
        if (!this.blobMode) {
            const video = event.target
            this.video2Blob(video).subscribe((e) => {
                console.log(e)
            }, (e) => {
                console.error(e)
            })
        }
    }

    video2Blob(video): Observable<any> {
        this.blobMode = true
        return new Observable((observable) => {
            let xhr = new XMLHttpRequest()
            xhr.open('GET', this.videoSrc, true)
            xhr.responseType = 'arraybuffer'
            xhr.onload = function(e) {
                if (this['status'] == 200) {
                    const blob = new Blob([this['response']], { type: 'video/mp4' })
                    const blobUrl = window.URL.createObjectURL(blob)
                    video.src = blobUrl

                    observable.next(true)
                }
            }
            xhr.onerror = function(e) {
                observable.error(e)
            }
            xhr.send()
        })
    }

    toggleFullscreen(event) {
        console.debug('toggleFullscreen')
    }

    @Input() set videoId(digest: string) {
        this._videoId = digest
        this.setVideoSrcAndThumb(digest)
    }

    private setVideoSrcAndThumb(digest) {
        if (digest) {
            if (digest.startsWith(imageUrl)) {
                digest = digest.replace(imageUrl, '')
            }
            this.videoSrc = imageUrl + digest
            this.urlThumbnail = getThumbnail(digest)
        } else {
            this.videoSrc = ''
            this.urlThumbnail = ''
        }
    }

    private isIOS() {
        return window.navigator.userAgent.match(/iOS|iPhone|iPad/)
    }

}



// WEBPACK FOOTER //
// ./src/app/commons/base-video/base-video.component.ts